import type { UtaProps } from '../../types/flight';

export const optionalUtasAcrossFares: Partial<UtaProps>[] = ['overheadBag', 'security'];
